'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index = require('../../../../../../../node_modules/@radix-ui/react-dropdown-menu/dist/index.cjs');
var Skeleton_web = require('../../../atoms/Skeleton/Skeleton.web.cjs');
var Content_web_styles = require('./Content.web.styles.cjs');

/**
 * Sub component of DropdownMenu that holds the content to be displayed
 */ const Content = ({ customDropdownWidth, side = "bottom", align = "center", isLoading = false, children })=>{
    const contentStyles = [
        Content_web_styles.content,
        customDropdownWidth && Content_web_styles.customWidth(customDropdownWidth)
    ];
    const skeleton = /*#__PURE__*/ jsxRuntime.jsxs("div", {
        css: Content_web_styles.skeleton,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx(Skeleton_web.Skeleton, {
                variant: "typography",
                width: "100%"
            }),
            /*#__PURE__*/ jsxRuntime.jsx(Skeleton_web.Skeleton, {
                variant: "typography",
                width: "100%"
            }),
            /*#__PURE__*/ jsxRuntime.jsx(Skeleton_web.Skeleton, {
                variant: "typography",
                width: "100%"
            })
        ]
    });
    return /*#__PURE__*/ jsxRuntime.jsx(index.Portal, {
        children: /*#__PURE__*/ jsxRuntime.jsx(index.Content, {
            side: side,
            align: align,
            css: contentStyles,
            className: "DropdownMenuContent",
            sideOffset: 5,
            children: isLoading ? skeleton : children
        })
    });
};
Content.displayName = "DropdownMenu.Content";

exports.Content = Content;
//# sourceMappingURL=Content.web.cjs.map
